import React from "react";
import { toast } from "react-toastify";
import { Button, FullScreenLoading, TextInput } from "src/Components";
import { IFixedBasePriceConfig } from "src/Interfaces/coveredCall";
import {
  getFixedBasePriceConfig,
  setFixedBasePriceConfig,
} from "src/Requests/coveredCall";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
  onApplied: () => void;
}

const FixedBasePriceSettingsModal: React.FC<IProps> = ({
  onClose,
  onApplied,
}) => {
  const [loading, setLoading] = React.useState(true);
  const [config, setConfig] = React.useState<IFixedBasePriceConfig>({
    baseInstruments: [],
  });

  React.useEffect(() => {
    getFixedBasePriceConfig()
      .then(setConfig)
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changePrice = (instrumentId: string, value: unknown) => {
    const normalizedValue = value === "" || value == null ? null : Number(value);
    setConfig((current) => ({
      ...current,
      baseInstruments: current.baseInstruments.map((item) =>
        item.instrumentId === instrumentId
          ? { ...item, price: normalizedValue }
          : item,
      ),
    }));
  };

  const submit = () => {
    setLoading(true);
    setFixedBasePriceConfig(config)
      .then((response) => {
        if (!response.data) {
          toast.error(response.msg);
          return;
        }
        toast.success(response.msg || "با موفقیت ثبت شد");
        onApplied();
        onClose();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex w-full min-w-0 flex-col gap-4 p-2">
      {loading ? <FullScreenLoading /> : null}
      <div className="text-center font-bold">قیمت نماد پایه</div>
      <div className="max-h-[60vh] overflow-y-auto">
        <div className="grid grid-cols-[110px_210px] justify-center gap-2 text-sm">
          <div className="font-bold">نماد پایه</div>
          <div className="font-bold">قیمت ثابت</div>
          {config.baseInstruments.map((item) => (
            <React.Fragment key={item.instrumentId}>
              <div className="flex items-center">{item.instrumentName}</div>
              <TextInput
                label="قیمت ثابت"
                name="price"
                value={item.price?.toString() ?? ""}
                onChange={(_, value) => changePrice(item.instrumentId, value)}
                classname="ltr text-right"
                kind="price"
              />
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="mr-auto w-[100px]">
        <Button
          onClick={submit}
          text="ثبت"
          variant="contained"
          disabled={loading}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default FixedBasePriceSettingsModal;
